module.exports = __webpack_public_path__ + "media/site/images/products/eplaning-flat-screen2-d47af7ff73c1798f5f462cbace55e6f3.png";